export default __webpack_public_path__ + "static/media/outdoorSign.c0543b18.jpg";